
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  position: relative;
  margin: auto;
  display: block;
  aspect-ratio: 16 / 9;
  width: 100%;
  overflow: hidden;
  border-radius: 1rem;
  max-width:1440px
}

.overlay {
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  cursor: pointer;
  background-size: cover;
  background-position: center;
  color: var(--neutral-white);
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms
}

.overlay-content {
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color:rgba(0, 0, 0, 0.4);
}

.overlay-content button idb-icon {
  font-size: var(--fs-lg);
  line-height: var(--lh-lg)
}

@media (min-width: 640px) {

  .overlay-content button idb-icon {
    font-size: var(--fs-3xl) !important;
    line-height: var(--lh-3xl) !important
  }
}

@media (min-width: 768px) {

  .overlay-content button idb-icon {
    font-size: var(--fs-5xl) !important;
    line-height: var(--lh-5xl) !important
  }
}

.overlay-text {
  width: 85%;
  text-align: center;
  font-size: var(--fs-sm);
  line-height: var(--lh-sm)
}

@media (min-width: 640px) {

  .overlay-text {
    width: 65%
  }

  .overlay-text {
    font-size: var(--fs-2xl);
    line-height: var(--lh-2xl)
  }
}

@media (min-width: 1024px) {

  .overlay-text {
    width: 50%
  }
}

@media (min-width: 1440px) {

  .overlay-text {
    width: 40%
  }
}

.overlay-content.top {
  justify-content: flex-start;
  padding-top: 2rem
}

.overlay-content.center {
  justify-content: center
}

.overlay-content.bottom {
  justify-content: flex-end;
  padding-bottom: 2rem
}

.video-container {
  display: none;
  height: 100%;
  width: 100%
}

.video-container.active {
  display: block
}

.close-button {
  position: absolute;
  top: 0.625rem;
  right: 0.625rem;
  z-index: 10;
  height: 40px;
  width: 40px;
  cursor: pointer;
  border-radius: 9999px;
  background-color: var(--neutral-black)
}

@media (min-width: 768px) {

  .close-button {
    height: 60px !important
  }

  .close-button {
    width: 60px
  }
}

.close-button idb-icon {
  font-size: var(--fs-xl);
  line-height: var(--lh-xl)
}

@media (min-width: 768px) {

  .close-button idb-icon {
    font-size: var(--fs-3xl) !important;
    line-height: var(--lh-3xl) !important
  }
}

iframe {
  height: 100%;
  width: 100%;
  border-style: none
}

idb-icon {
  cursor: pointer;
  color: var(--neutral-white)
}

idb-icon:hover {
  color: var(--blue-responsible-main)
}

`;